import React from 'react';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
const PopoverPopover = ({ contentClassName , referenceClassName , children , tooltipOffset =[
    0,
    8
] , placement , secondaryPlacement , onClose , onReferenceClick , renderPopover , renderReference  })=>{
    return /*#__PURE__*/ React.createElement(PositionOnlyPopperPopover, {
        className: referenceClassName,
        placement: placement,
        secondaryPlacement: secondaryPlacement,
        isVisible: true,
        onClickOutside: onClose,
        offsetModifier: tooltipOffset,
        contentClassName: contentClassName,
        onReferenceClick: onReferenceClick,
        popoverContent: ()=>renderPopover && renderPopover({
                closeTooltip: onClose
            }),
        renderReference: renderReference
    }, children);
};
PopoverPopover.displayName = 'PopoverPopover';
export default PopoverPopover;
